import type { IconName } from "@/components/icons";

// Product destinations use domain names. Design screen codes stay in preview/.
export type DataDestination = "datasets" | "subsets" | "views" | "uploads" | "changes" | "reviews" | "workflows" | "lineage" | "audit" | "deletions";
type NavigationDestination = DataDestination | "models" | "model-factory" | "jobs" | "train" | "inference";
export type NavigationItem = { id: NavigationDestination; label: string; icon: IconName; path?: string; description?: string; badge?: "coming-soon" | "beta" };
export type PreviewNavigation = {
  home: string;
  links: Readonly<Record<Exclude<DataDestination, "workflows" | "subsets">, string> & { workflows?: string; subsets?: string }>;
  active?: DataDestination;
};

// Shell is the sole renderer. A missing path is a planned product destination;
// only the DEV review adapter supplies an alternative link for it.
export const DATA_NAV: NavigationItem[] = [
  { id: "datasets", label: "Datasets", icon: "datasets", path: "/datasets" },
  { id: "subsets", label: "Subsets", icon: "views", path: "/subsets", badge: "beta" },
  { id: "views", label: "Views", icon: "views", path: "/views", badge: "beta" },
];
export const PREPARE_NAV: NavigationItem[] = [
  { id: "uploads", label: "Uploads", icon: "upload", path: "/uploads" },
  { id: "changes", label: "Merge plans", icon: "merge", path: "/merge-plans" },
  { id: "reviews", label: "Reviews", icon: "review", path: "/reviews" },
  { id: "lineage", label: "Lineage", icon: "lineage", path: "/lineage", badge: "beta", description: "Beta · available to use" },
];
export const MODEL_NAV: NavigationItem[] = [
  { id: "models", label: "Models", icon: "model", path: "/models" },
  { id: "train", label: "Train a model", icon: "training", path: "/train" },
  { id: "inference", label: "Inference & Test", icon: "model", path: "/inference", badge: "beta" },
];
export const OPERATIONS_NAV: NavigationItem[] = [
  { id: "workflows", label: "Workflows", icon: "workflow", path: "/workflows", badge: "coming-soon",
    description: "Workflow is Celia’s shared operations layer: coordinate data, training, evaluation and review, follow lineage end to end, and let agents work through the same flow." },
  { id: "jobs", label: "Jobs & Runs", icon: "jobs", path: "/jobs" },
];
export function destination(item: NavigationItem, slug: string, overrides?: Partial<Record<NavigationDestination, string>>): string | undefined {
  return overrides?.[item.id] ?? (item.path ? `/p/${encodeURIComponent(slug)}${item.path}` : undefined);
}
